// extracted by mini-css-extract-plugin
export var buttonContainer = "style-module--buttonContainer--70aa1";
export var complete = "style-module--complete--9a625";
export var email = "style-module--email--83435";
export var errorMessage = "style-module--errorMessage--bc038";
export var forget = "style-module--forget--19e06";
export var form = "style-module--form--41106";
export var google = "style-module--google--2d749";
export var input = "style-module--input--14802";
export var inputContainer = "style-module--inputContainer--e91c6";
export var question = "style-module--question--bb966";
export var resent = "style-module--resent--c9751";
export var resetPassword = "style-module--resetPassword--cf971";
export var text = "style-module--text--9c8af";
export var title = "style-module--title--2e81e";